import { Linkedin, Twitter, Youtube } from "@assets/icons/icons";

export const FOOTER_NAVIGATION = {
  company: [
    { name: "About Us", href: "/about" },
    { name: "Contact Us", href: "/contact" },
    { name: "Privacy Policy", href: "/privacy-policy" },
    { name: "Terms & Conditions", href: "/terms-conditions" },
    { name: "FAQ", href: "/faqs" },
  ],
  resources: [
    { name: "Resume Builder", href: "/resume" },
    { name: "Job Search", href: "/jobs" },
    { name: "Courses", href: "/courses" },
    { name: "Plans", href: "/plans" },
  ],
  social: [
    { name: "LinkedIn", href: "#", icon: Linkedin },
    { name: "Twitter", href: "#", icon: Twitter },
    { name: "YouTube", href: "#", icon: Youtube },
  ],
};
